export class ConnectionAttemptResponse {
    constructor(Text, ErrorCode) {
        this.text = Text;
        this.ErrorCode = ErrorCode;
    }
}
